module.exports = __webpack_public_path__ + "img/alarm-bg.3ab3103c.png";